'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchUploadSignIfNeeded = exports.FETCH_UPLOADSIGN_FAILURE = exports.FETCH_UPLOADSIGN_SUCCESS = exports.FETCH_UPLOADSIGN_REQUEST = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _api = require('../api');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FETCH_UPLOADSIGN_REQUEST = exports.FETCH_UPLOADSIGN_REQUEST = 'FETCH_UPLOADSIGN_REQUEST';
var FETCH_UPLOADSIGN_SUCCESS = exports.FETCH_UPLOADSIGN_SUCCESS = 'FETCH_UPLOADSIGN_SUCCESS';
var FETCH_UPLOADSIGN_FAILURE = exports.FETCH_UPLOADSIGN_FAILURE = 'FETCH_UPLOADSIGN_FAILURE';

var fetchUploadSignRequest = function fetchUploadSignRequest() {
    return {
        type: FETCH_UPLOADSIGN_REQUEST
    };
};

var fetchUploadSignSuccess = function fetchUploadSignSuccess(json) {
    var accessid = json.accessid,
        policy = json.policy,
        signature = json.signature,
        dir = json.dir,
        host = json.host,
        callback = json.callback;

    return {
        accessid: accessid, policy: policy, signature: signature, dir: dir, host: host, callback: callback,
        type: FETCH_UPLOADSIGN_SUCCESS,
        receivedAt: +(0, _moment2.default)()
    };
};
var fetchUploadSignFailure = function fetchUploadSignFailure(error) {

    var ok = error.ok,
        status = error.status,
        statusText = error.statusText,
        type = error.type,
        url = error.url;

    return {
        type: FETCH_UPLOADSIGN_FAILURE,
        error: { ok: ok, status: status, statusText: statusText, type: type, url: url }
    };
};

var shouldFetchUploadSign = function shouldFetchUploadSign(state) {
    var uploadSign = state.uploadSign;
    if (uploadSign.isFetching) {
        return false;
    }
    if (uploadSign.error) {
        return false;
    }
    return true;
};

var fetchUploadSignIfNeeded = exports.fetchUploadSignIfNeeded = function fetchUploadSignIfNeeded(isPublic) {
    return function (dispatch, getState) {
        if (shouldFetchUploadSign(getState())) {
            return dispatch(function (dispatch) {
                dispatch(fetchUploadSignRequest());
                return (0, _api.fetchUploadSign)(isPublic).then(function (response) {
                    return dispatch(fetchUploadSignSuccess(response.data));
                }).catch(function (error) {
                    dispatch(fetchUploadSignFailure(error));
                });
            });
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/upload_sign.js
// module id = 904
// module chunks = 0